import React, { ReactNode, createContext, useReducer } from "react";

import { Configs } from "./model";

const ConfigStateContext = createContext<Configs>({});
const ConfigDispatchContext = createContext(null);
export const defaultState: Configs = {
	country_id: null,
	main_domain: "www.infocasas.com.uy",
	site_name: "InfoCasas",
};

const reducer = (state: Configs, action): Configs => {
	switch (action.type) {
		case "set":
			return { ...action.payload };
		case "merge":
			return { ...state, ...action.payload };
		case "reset":
			return { ...defaultState };
		default:
			throw new Error("no funciona");
	}
};

const ConfigurationsProvider = ({
	children,
	initialState = null,
	active,
}: {
	children: ReactNode;
	initialState: Configs;
	active: boolean;
}) => {
	const [state, dispatch] = useReducer(reducer, initialState ?? defaultState);

	if (!active) return <>{children}</>;

	return (
		<ConfigDispatchContext.Provider value={dispatch}>
			<ConfigStateContext.Provider value={state}>{children}</ConfigStateContext.Provider>
		</ConfigDispatchContext.Provider>
	);
};

export { ConfigStateContext, ConfigDispatchContext, ConfigurationsProvider };
